// Character -> value table used by the SAT check-digit algorithm. The index of
// each character in this string is its numeric value (0-38).
const RFC_CHAR_VALUES = "0123456789ABCDEFGHIJKLMN&OPQRSTUVWXYZ Ñ";

const RFC_REGEX =
  /^[A-ZÑ&]{3,4}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[A-Z\d]{2}[A-Z\d]$/;

/**
 * Normalizes a Mexican RFC: uppercase, no separators, at most 13 characters.
 */
export const formatRfc = (value: string): string => {
  if (!value) return "";
  return value
    .toUpperCase()
    .replace(/[^A-ZÑ&0-9]/g, "")
    .slice(0, 13);
};

const rfcCheckDigit = (rfc: string): string => {
  // A persona moral RFC (12 characters) is left-padded with a space to 13 so
  // the weighted sum runs over a fixed 12-character window.
  const padded = rfc.padStart(13, " ");
  const total = padded
    .slice(0, 12)
    .split("")
    .reduce(
      (acc, char, position) =>
        acc + RFC_CHAR_VALUES.indexOf(char) * (13 - position),
      0,
    );
  const check = 11 - (total % 11);

  if (check === 11) return "0";
  if (check === 10) return "A";
  return check.toString();
};

/**
 * Validates a Mexican RFC (13 characters for a persona física, 12 for a
 * persona moral), including its check digit.
 */
export const checkRfc = (rfc: string): boolean => {
  if (!rfc) return false;

  const clean = formatRfc(rfc);
  if (!RFC_REGEX.test(clean)) return false;

  return rfcCheckDigit(clean) === clean.charAt(clean.length - 1);
};
